import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get, partial, isPlainObject, capitalize, isEqual } from 'lodash';
import Parcel from 'single-spa-react/parcel';
import { mountRootParcel } from 'single-spa';

import { CprLoader } from 'canopy-styleguide!sofe';
import { NavContent } from 'primary-navbar!sofe';
import Section from './sections/section.component.js';
import SectionHeaderForSourceForm from './sections/section-header-for-source-form.component.js';
import * as sectionTypes from './sections/section.types.js';
import FormViewSwitch from './form-view-switch.component.js';
import Subheader from './sections/subheader.component.js';
import SectionFooter from './sections/section-footer.component.js';
import blockStyles from './blocks/block.styles.css';
import styles from './source-form-for-tax-form.styles.css';

import * as uiFormsActions from './ui-forms.actions.js';
import * as answerActions from './answers/answer.actions.js';
import * as summaryTableActions from './summary-table/summary-table.actions.js';
import * as sectionActions from './sections/section.actions.js';
import { getSourceForm } from './source-form-layout.actions.js';
import { formSetMap } from '../tax-forms/tax-return.helper.js';

const ID_OF_FIRST_SECTION = 1;

@connect(state => ({
  section: state.section.activeSection,
  questionsToShowRequiredWarnings:
    state.section.questionsToShowRequiredWarnings,
  scrollJump: state.section.scrollJump,
  answers: state.answers,
  sourceFormLayout: state.sourceFormLayout,
  engagement: state.engagement,
  client: state.client,
  loggedInUser: state.context.loggedInUser,
  formSet: state.smeVersion.formSet,
  tenant: state.context.tenant,
  version: state.smeVersion.version,
  revision: state.smeVersion.revision,
  uiFormsState: state.uiForms,
  summaryTable: state.summaryTable,
  clientSurvey: state.clientSurvey
}))
export default class SourceFormForTaxForm extends React.Component {
  constructor() {
    super();
    this.state = {
      fetchingSection: false,
      lastFetchTime: new Date().getTime(),
      lastFetchParams: null
    };
  }

  fetchSection(props) {
    const params = {
      clientId: props.match.params.clientId,
      engagementId: props.match.params.engagementId,
      versionId: props.version.id,
      revisionId: props.revision.id,
      sourceFormId: props.match.params.sourceFormId,
      sectionId: props.match.params.sectionId || '0',
      TaxpayerType: capitalize(props.engagement.taxpayer_type)
    };

    if (
      isEqual(params, this.state.lastFetchParams) &&
      new Date().getTime() - this.state.lastFetchTime < 1000
    ) {
      /* No need to retrieve the same source form more than once in a row
       */
      return;
    }

    this.mounted &&
      this.setState({
        fetchingSection: true,
        lastFetchParams: params,
        lastFetchTime: new Date().getTime()
      });

    props.dispatch(
      getSourceForm(
        params,
        fetchSectionErr.bind(this),
        fetchSectionSuccess.bind(this)
      )
    );

    function fetchSectionErr(err) {
      this.mounted &&
        this.setState({
          fetchingSection: false
        });
    }

    function fetchSectionSuccess() {
      this.mounted &&
        this.setState({
          fetchingSection: false
        });
    }
  }
  componentWillMount() {
    this.componentWillReceiveProps(this.props);

    this.actions = {
      ...bindActionCreators(uiFormsActions, this.props.dispatch),
      ...bindActionCreators(answerActions, this.props.dispatch),
      ...bindActionCreators(summaryTableActions, this.props.dispatch),
      ...bindActionCreators(sectionActions, this.props.dispatch)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.match.params.sectionId &&
      !window.location.hash.endsWith('/sections/0')
    ) {
      // We don't know which section to show. Show section 0 (the first section in the source form).
      this.props.dispatch(sectionActions.resetSourceFormSection());
      window.location.hash += '/sections/0';
      return false;
    }

    let activeSectionLoaded =
      nextProps.match.params.sectionId &&
      nextProps.match.params.sectionId === nextProps.section.id &&
      nextProps.match.params.sourceFormId ===
        this.props.match.params.sourceFormId;

    if (
      nextProps.section.id &&
      nextProps.match.params.sectionId === '0' &&
      nextProps.match.params.sourceFormId ===
        this.props.match.params.sourceFormId
    ) {
      activeSectionLoaded = true;
    }

    if (
      !activeSectionLoaded &&
      nextProps.version &&
      nextProps.revision &&
      !this.state.fetchingSection &&
      !nextProps.engagement.isDefaultEngagement
    ) {
      this.mounted &&
        this.setState({
          fetchingSection: true
        });
      this.fetchSection(nextProps);
    }

    if (this.state.fetchingSection && activeSectionLoaded) {
      this.mounted &&
        this.setState(
          {
            fetchingSection: false
          },
          () => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
        );
    }
  }

  render() {
    const formView = 'sourceForm';
    const sectionId = this.props.activeSection
      ? this.props.section.id
      : this.props.match.params.sectionId;
    const isTaxPrep = get(this.props, 'version.product') === 'taxPrep';

    return (
      <NavContent
        className={`wide-menu ${styles.mainContent}`}
        hasTopnavSecondary={false}
        contactMenuPossible={true}>
        <div className="cps-fixed-focus">
          {(this.props.sourceFormLayout.taxForm || isTaxPrep) && (
            <FormViewSwitch
              isTaxPrep={isTaxPrep}
              formSwitchLeft={this.props.uiFormsState.formSwitchLeft}
              formView={formView}
              engagementId={this.props.match.params.engagementId}
              clientId={this.props.match.params.clientId}
              taxFormId={this.props.sourceFormLayout.taxForm}
              sourceFormId={this.props.match.params.sourceFormId}
              sourceFormName={this.props.sourceFormLayout.name}
              sectionId={sectionId}
              userIsSME={!!this.props.loggedInUser.effective_permissions.sme}
            />
          )}
          {this.props.sourceFormLayout.name ? (
            <SectionHeaderForSourceForm
              contactMenuPossible={true}
              width={this.props.uiFormsState.cardWidth}
              left={this.props.uiFormsState.cardLeft}
              formName={this.props.sourceFormLayout.name}
              formView={formView}
              sectionMessage={this.props.uiFormsState.sectionMessage}
            />
          ) : null}
          <div className={`cps-card +thin`}>{getSection.bind(this)()}</div>
        </div>
      </NavContent>
    );

    function getSection() {
      // Section hasn't loaded yet
      if (!this.props.section.name || this.state.fetchingSection) {
        return (
          <div className={`${blockStyles.loaderWrapper}`}>
            <CprLoader />
          </div>
        );
      }

      const hasClientSurveyMetadata =
        this.props.clientSurvey.survey === 'default';
      const alternateAnswerSets = hasClientSurveyMetadata
        ? ['clientSurveys', 'crm']
        : null;
      const overrideAnswerSet = hasClientSurveyMetadata ? 'taxForms' : null;

      return (
        <div>
          <Subheader text={this.props.section.name} />
          <Section
            actions={{
              ...this.actions,
              updateAnswer: partial(this.actions.updateAnswer, {
                clientId: this.props.match.params.clientId,
                engagementId: this.props.match.params.engagementId,
                sourceFormId: this.props.match.params.sourceFormId,
                sectionId,
                versionId: this.props.version ? this.props.version.id : null,
                revisionId: this.props.revision ? this.props.revision.id : null,
                answers: this.props.answers
              })
            }}
            scrollJump={this.props.scrollJump}
            answers={this.props.answers}
            clientId={this.props.match.params.clientId}
            formName={this.props.sourceFormLayout.name}
            engagementId={this.props.match.params.engagementId}
            sourceFormId={this.props.match.params.sourceFormId}
            taxFormId={this.props.sourceFormLayout.taxForm}
            activeSection={this.props.section}
            questionsToShowRequiredWarnings={
              this.props.questionsToShowRequiredWarnings
            }
            sections={this.props.sourceFormLayout.sections}
            summaryTable={this.props.summaryTable}
            alternateAnswerSets={alternateAnswerSets}
            overrideAnswerSet={overrideAnswerSet}
            showDescription={false}
          />
          <SectionFooter
            clientId={this.props.match.params.clientId}
            engagementId={this.props.match.params.engagementId}
            sourceFormId={this.props.match.params.sourceFormId}
            taxFormId={this.props.sourceFormLayout.taxForm}
            activeSection={this.props.section}
            sections={this.props.sourceFormLayout.sections}
            actions={this.actions}
          />
          {window.loggedInUser.effective_permissions.sme && (
            <Parcel
              config={() =>
                SystemJS.import('sme-qa-ui!sofe').then(
                  mod => mod.floatingTestMenu
                )
              }
              mountParcel={mountRootParcel}
              wrapWith="div"
              appendTo={document.body}
              engagementId={get(this.props, 'params.engagementId', null)}
              revisionId={get(this.props, 'revision.id', null)}
              versionId={get(this.props, 'version.id', null)}
              clientId={get(this.props, 'params.clientId', null)}
              folderIds={[formSetMap[this.props.formSet]]}
              taxFormName={get(this.props, 'sourceFormLayout.taxForm', null)}
              taxFormType={get(this.props, 'engagement.forms_version', null)}
            />
          )}
        </div>
      );
    }
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
    this.props.dispatch(sectionActions.resetSourceFormSection());
  }
}
